import { NotificationSettings } from '../components/NotificationSettings';

export default function SettingsPage() {
  return (
    <div className="page-stack narrow">
      <section className="page-heading">
        <span className="eyebrow">Preferenze</span>
        <h1>Impostazioni</h1>
        <p className="muted">Gestisci notifiche e preferenze per questo dispositivo.</p>
      </section>
      <NotificationSettings />
      <section className="panel">
        <h2>Installazione iPhone</h2>
        <p className="muted">Apri l’app da Safari, tocca Condividi e scegli “Aggiungi alla schermata Home”. Da lì l’app si comporta come una PWA installata.</p>
      </section>
    </div>
  );
}
